import { createActionGroup, props } from "@ngrx/store";
import { CustomerType } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataCustomerTypesActions = createActionGroup({
    source: "Data / Customer Types",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ customerTypes: CustomerType[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
